import type { MoveScore } from "../models/move-model";

export const toNormalizedMoveScore = (
    score: MoveScore,
    isWhiteTurn: boolean
): MoveScore => {
    const normalizedScore = isWhiteTurn ? score.score : -score.score;
    return {
        type: score.type,
        score: normalizedScore,
    };
};

export const EvaluationScoreUtil = {
    toNormalizedMoveScore,
};
